<template>
    <div class="workordrAssign">
        <div class="workordr_tip">
            <i class="icon-icon_tip"></i>审核承办单位向指挥中心提交的处置结果
        </div>
        <div class="workordr_content">
            <div class="workordr_content_title">
                <div class="workordr_content_title_left">
                    <span></span>
                    <p>承办单位处理结果</p>
                </div>
                <div class="workerProgress_title_right">
                    <img src="../../assets/images/ico_bpld@1x.png" alt="">
                    {{queryWordorderMessageData.czCzjsmc}}
                </div>
            </div>
            <div class="workordr_result">
                <div class="workordr_result_title">
                    <span class="icon-build"></span>
                    <span>
                       {{queryWordorderMessageData.czCzdwmc}}
                    </span>
                    <span><el-icon><clock/></el-icon></span>
                    <span>
                       {{queryWordorderMessageData.updateTime}}
                    </span>
                </div>
                <div class="workordr_result_main">
                    {{queryWordorderMessageData.czCzjgwb}}
                </div>
            </div>
        </div>
        <TimeLine_file :files="queryWordorderMessageData.files" v-if="queryWordorderMessageData.files && queryWordorderMessageData.files.length>0"></TimeLine_file>
    </div>
    <div class="workordrAssign">
        <div class="workordr_content">
            <div class="workordr_content_title">
                <div class="workordr_content_title_left">
                    <span></span>
                    <p>审查结果</p>
                    <el-radio-group v-model="ruleForm.czCzjgzt" >
                        <el-radio-button label="1">通过</el-radio-button>
                        <el-radio-button label="0">驳回</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <el-form label-width="90px"
                     :model="ruleForm"
                     :rules="rules"
                     label-position="left"
                     ref="ruleFormRef">
                <div class="workordr_main">
                    <el-form-item label="处理结果" v-if="ruleForm.czCzjgzt=='1'" prop="czCzjgwb">
                        <el-input v-model="ruleForm.czCzjgwb" :autosize="{ minRows: 5}" maxlength="2000" show-word-limit type="textarea"/>
                    </el-form-item>
                    <el-form-item label="驳回原因" v-if="ruleForm.czCzjgzt=='0'" prop="czCzjgwb">
                        <el-input v-model="ruleForm.czCzjgwb" :autosize="{ minRows: 5}" maxlength="2000" show-word-limit type="textarea"/>
                    </el-form-item>
                    <el-form-item label="">
                        <div style="color:red">结案条件：{{queryWordorderMessageData.jatj}}</div>
                    </el-form-item>
                    <!--<Workorder_file @deleteFile="deleteFile" @fileListToParent="fileListToParent"></Workorder_file>-->
                </div>
                <el-form-item class="workordrAssign_btn">
                    <div class="workordrAssign_btn_cancle" @click="cancleClick">
                        取消
                    </div>
                    <div class="workordrAssign_btn_sure" @click="submitForm(ruleFormRef)">
                        确认
                    </div>
                    <!--<el-popconfirm title="确认提交区中心吗？">-->
                    <!--<template #reference>-->
                    <!--<div class="workordrAssign_btn_sure">-->
                    <!--确认-->
                    <!--</div>-->
                    <!--</template>-->
                    <!--</el-popconfirm>-->
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reactive, computed, ref, getCurrentInstance, onMounted,watch} from 'vue'
    import {useStore} from 'vuex';
    import {ElMessageBox,ElLoading} from 'element-plus'
    import TimeLine_file from "../timeLine/TimeLine_file.vue"
    export default {
        name: "WorkProgress_sh",
        props: ["gdId","workProgressComponentChildData"],
        components: {
            TimeLine_file
        },
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const ruleFormRef = ref()
            const ruleForm = reactive({
                "czCzlx": "JGSH",
                "gdId": props.gdId,
                "czCzjgzt": 1,
                "czCzjgwb":"",
                "czFpdxid":props.workProgressComponentChildData.czFpdxid,
            });

            let queryWordorderMessageData = ref([])
            const rules = reactive({
                czCzjgwb: [
                    {required: true, message: "请输入处理结果", trigger: 'blur'},
                ]
            });
            watch(()=>ruleForm.czCzjgzt,(newVal)=>{
                if(newVal =="1"){
                    rules.czCzjgwb[0].message="请输入处理结果"
                }else{
                    rules.czCzjgwb[0].message="请输入驳回原因"
                }
            })
            // const radioGroupChange = (param) => {
            //     if (param == 1) {
            //         ruleForm.czCzjgwb = "";
            //     }
            // }
            const submitForm = (param) => {
                if (!param) return
                let loading;
                param.validate((valid, fields) => {
                    if (valid) {
                        ElMessageBox.confirm('请确认是否继续', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            callback: (action) => {
                                if(action=="confirm"){
                                    loading = ElLoading.service({
                                        lock: true,
                                        text: 'Loading',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                    })
                                    proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                        context.emit("workProgressSure");
                                        loading.close()
                                    }).catch(e=>{
                                        loading.close();
                                    });
                                }
                            },
                        })
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            };
            onMounted(() => {
                queryWordorderMessage();
            })
            const queryWordorderMessage = () => {
                proxy.$axios.post("/jgfast/wgsj/selCbdwcljg", {
                    "gdId": props.gdId,
                    "czFpdxid": props.workProgressComponentChildData.czFpdxid, //处置单位
                    "czFpdxjs": props.workProgressComponentChildData.czFpdxjs //处置单位角色
                }).then((res) => {
                    queryWordorderMessageData.value = res.data;
                });
            }
            //取消事件
            const cancleClick = () => {
                context.emit("workProgressCancle");
            }
            const fileListToParent=(param)=>{
                if(param){
                    ruleForm.fileIds.push(param.id);
                }
            }
            const deleteFile=(param)=>{
                ruleForm.fileIds.splice(param, 1)
            }
            return {
                ruleForm,
                rules,
                ruleFormRef,
                submitForm,
                queryWordorderMessageData,
                cancleClick,
                fileListToParent,
                deleteFile
            }
        }
    }
</script>

<style lang="less">
.workerProgress_title_right{
    display: flex;
    color: rgba(96,98,102,1);
    font-family: Microsoft YaHei;
    font-size: 14px;
    align-items: center;
    img{
        width: 16px;
        height: 16px;
    }
    span{
        margin:0 4px;
    }
}
</style>

